import { VerticalBarToolTip, VerticalBarToolTipArrow, VerticalBarToolTipZone } from "styles/bar";

import React from "react";
import colors from "styles/colors";
import formatMoney from "../../modules/utils/formatMoney";
import useRect from "modules/utils/useRect";

const MyToolTip = ({ tooltipModel }) => {
  //eslint-disable-next-line no-unused-vars
  const [rect, ref] = useRect();
  const value = tooltipModel.dataPoints[0].value || tooltipModel.dataPoints[1].value;
  const left = tooltipModel.caretX - (ref.current ? ref.current.offsetWidth / 2 : 0);
  const top = tooltipModel.caretY - 40;
  return (
    <VerticalBarToolTipZone top={top} left={left} ref={ref}>
      <VerticalBarToolTip
        fontSize="10px"
        bold={false}
        color={colors.tooltip2Text}
        bgColor={colors.tooltip2}
        radius={ref.current ? ref.current.offsetHeight / 2 + "px" : null}
      >
        {formatMoney(value)}
      </VerticalBarToolTip>
      <VerticalBarToolTipArrow bgColor={colors.tooltip2} />
    </VerticalBarToolTipZone>
  );
};

const exhaustionToolTip = (tooltipModel, setTooltip) => {
  if (tooltipModel.body) setTooltip(<MyToolTip tooltipModel={tooltipModel} />);
  if (tooltipModel.opacity === 0) setTooltip(null);
};

export default exhaustionToolTip;
